import { isApp, isIosApp, isGamesApp, appInfo } from './device.js'

// 解析版本号
const parseVersion = (version = '') => {
  const arr = version.split('.')
  return {
    // 大版本号
    major: arr[0],
    // 小版本号
    minor: arr[1],
    // 次版本号
    patch: arr[2]
  }
}

/**
 * 获取 app 版本号
 */
export const getVersion = () => {
  let version = appInfo.appVersion
  const { major, minor, patch } = parseVersion(version)
  return {
    // 版本号
    version,
    // 大版本号
    major,
    // 小版本号
    minor,
    // 次版本号
    patch
  }
}

//
/**
 * 比较当前 app 版本和目标版本
 * @param {String|Object} options   目标版本或目标版本对象
 * @param {String} options.android  android app version
 * @param {String} options.ios      ios app version
 * @param {String} options.iosGame  ios games app version
 * @return {Boolean}   true - 当前版本大或相等， false - 当前版本小
 */
export const compireVersion = (options) => {
  if (!isApp()) return true
  const defaultVersion = '1.0.0'
  // android app version
  let androidVersion = defaultVersion
  // ios app version
  let iosVersion = defaultVersion
  // ios msport aviator version
  let iosGameVersion = defaultVersion
  if (typeof options === 'string') {
    androidVersion = options
  } else if (typeof options === 'object') {
    androidVersion = options.android || defaultVersion
    iosVersion = options.ios || defaultVersion
    iosGameVersion = options.iosGame || defaultVersion
  }

  const current = getVersion() || defaultVersion
  let targetVersion = androidVersion
  if (isIosApp()) {
    targetVersion = iosVersion
  } else if (isGamesApp()) {
    targetVersion = iosGameVersion
  }

  // 版本相等就不用继续判断了
  if (current.version === targetVersion) {
    return true
  }

  const target = parseVersion(targetVersion)
  const compare = (a, b) => Number(a) > Number(b)

  if (current.major === target.major) {
    if (current.minor === target.minor) {
      return compare(current.patch, target.patch)
    } else {
      return compare(current.minor, target.minor)
    }
  } else {
    return compare(current.major, target.major)
  }
}
